import ErrorNotFound from './ErrorNotFound';
export default ErrorNotFound;
